export default {
  langSep: '|',
  colon: ':',
  searchPlaceholder: 'Please enter keywords.',
  siteTitle: 'Chenghong Technology',
  nav: {
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    applications: 'Industry Cases',
    news: 'News',
    services: 'Services',
    about: 'About',
    contact: 'Contact'
  },
  common: {
    home: 'Home',
    learnMore: 'Learn More',
    submit: 'Submit',
    backToList: 'Back to List',
    more: 'More+',
    inquiry: 'Inquiry',
    summary: 'Summary',
    watchVideo: 'Watch Video',
    noContent: 'No content available.',
    noNews: 'No news articles found.',
    noProducts: 'No products in this category.',
    noProductsSearch: 'No products found.',
    noCases: 'No application cases in this category.',
    noNewsSearch: 'No news found.',
    contentSoon: 'Content coming soon.',
    allNews: 'All News',
    newsDetail: 'News Detail'
  },
  news: {
    recommended: 'Recommended News',
    fontSize: 'Font Size',
    fontSmall: 'S',
    fontMedium: 'M',
    fontLarge: 'L',
    shareWechat: 'Share to WeChat',
    shareWeibo: 'Share to Weibo',
    shareQq: 'Share to QQ',
    shareVideo: 'Share to Channels'
  },
  homeMenu: {
    page1: 'Chenghong',
    page2: 'Products',
    page3: 'Industry Cases',
    page4: 'Chenghong',
    page5: 'News'
  },
  home: {
    productsTitle: 'Products',
    productsDesc: '',
    solutionsTitle: 'Industry Cases',
    oneStopTitle: '',
    oneStopDesc: '',
    leakTesters: 'Leak Testers',
    testFixtures: 'Test Fixtures',
    testPlatforms: 'Test Platforms',
    aboutTitle: '',
    aboutSubtitle: '',
    aboutText: '',
    newsTitle: 'News',
    newsSubtitle: '',
    newsEmpty: 'No news available yet. Please check back later or visit the news page.',
    statStandard: 'Standards',
    statPatents: 'Software Copyrights and Patents',
    statCases: 'Customer Cases',
    statBase: 'Production Base'
  },
  banner: {
    b1Title: '',
    b1Sub: '',
    b2Title: '',
    b2Sub: '',
    b3Title: '',
    b3Sub: '',
    b4Title: '',
    b4Sub: '',
    b5Title: '',
    b5Sub: ''
  },
  footer: {
    email: 'Email',
    hotline: 'Service Hotline',
    headquarters: 'Headquarters',
    factory: 'Production Base',
    links: 'Links',
    icp: '',
    psb: '',
    companyName: 'Chenghong Technology Co., Ltd.'
  },
  float: {
    contact: 'Contact',
    weekdays: 'Weekdays',
    dayoff: 'Day off',
    onlineConsult: 'Chenghong Technology',
    contactBtn: 'Contact',
    intelligentService: 'Intelligent customer service',
    contactPhone: 'Contact by phone',
    scanQr: 'Scan the QR code for inquiries.',
    scanWechat: 'Scan the QR code with WeChat.',
    inquirePurchase: 'Inquire about purchasing',
    oneOnOne: 'One-on-one professional service',
    inquiry: 'Inquiry',
    wechat: 'WeChat',
    feedback: 'Feedback',
    returnTop: 'Return Top',
    wechatOfficial: 'Chenghong Technology Official WeChat Account'
  },
  contact: {
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    pageTitle: 'Contact',
    name: 'Name',
    company: 'Company',
    message: 'Message',
    required: '*',
    success: 'Thank you! Your message has been submitted successfully.',
    fail: 'Submission failed. Please try again later.',
    navigate: 'Navigate',
    hotline: 'Customer Hotline',
    wechatService: 'WeChat Service',
    branchesTitle: 'Branches / Offices',
    addressCard: 'Chenghong Address',
    emailCard: 'Chenghong Email',
    hotlineCard: 'Service Hotline',
    inquiryTitle: 'Online Inquiry',
    inquiryType: 'Inquiry Type',
    typeService: 'Service',
    typeMarket: 'Market',
    typeRecruit: 'Recruitment',
    typeOther: 'Other',
    submit: 'Submit',
    reset: 'Reset',
    companyFullName: '',
    namePh: 'Your name',
    phonePh: 'Your phone number',
    phoneInvalid: 'Please enter a valid phone number (mobile or landline).',
    emailPh: 'Your email address',
    companyPh: 'Your company name',
    messagePh: 'Please describe your inquiry'
  },
  search: {
    title: 'Search Results',
    resultsFor: 'Results for',
    currentSearch: 'Current search: ',
    noResults: 'No results found.',
    products: 'Products',
    news: 'News'
  },
  faq: {
    pageTitle: 'FAQ & Support',
    searchPlaceholder: 'Enter host serial number or device model to find related questions.',
    searchHint: ''
  },
  service: {
    searchPlaceholder: 'Search',
    supportTitle: 'Product Support',
    breadcrumbService: 'Service & Support'
  },
  about: {
    jobTitle: 'Position',
    jobLocation: 'Location',
    jobDept: 'Department',
    jobType: 'Type',
    jobDate: 'Posted'
  },
  newsType: {
    0: 'Tech Wiki',
    1: 'Company News',
    2: 'Events',
    3: 'Industry Insights',
    4: 'CSR'
  },
  productNav: {
    'bubble-leak': 'Bubble Leak Detectors',
    airtightness: 'Airtightness Testers',
    'gas-detectors': 'Gas Detectors',
    'mass-spectrometers': 'Mass Spectrometers',
    'helium-leak': 'Helium Mass Spectrometer Leak Detectors',
    'test-platforms': 'Test Platforms',
    fixtures: 'Fixtures',
    accessories: 'Accessories',
    'helium-leak-detector': 'Helium Mass Spectrometer Leak Detectors',
    'mass-spectrometer': 'Mass Spectrometers',
    'gas-detector': 'Gas Detectors',
    'leak-tester': 'Airtightness Testers',
    'leak-point-detector': 'Leak Point Detectors',
    'test-platform': 'Test Platforms'
  },
  productDetail: {
    overview: 'Product Overview',
    specs: 'Specifications',
    scenarios: 'Application Scenarios',
    cases: 'Application Examples',
    recommended: 'Related recommendations',
    consult: 'Contact',
    share: 'Share',
    noSpecs: 'No specifications available.',
    noScenarios: 'No application scenarios available.',
    noCases: 'No application examples available.'
  },
  solutionNav: {
    'liquid-cooling': 'Liquid Cooling',
    automotive: 'Automotive',
    'hvac-refrigeration': 'HVAC/Refrigeration',
    hvac: 'HVAC/R',
    energy: 'Energy',
    battery: 'Battery',
    batteries: 'Batteries',
    semiconductor: 'Semiconductor',
    semiconductors: 'Semiconductors',
    'consumer-electronics': 'Consumer Electronics',
    'general-equipment': 'General Equipment',
    'medical-devices': 'Medical Devices',
    medical: 'Medical Devices',
    'home-appliances': 'Home Appliances',
    'defense-aerospace': 'Defense & Aerospace',
    aerospace: 'Aerospace & Defense',
    'new-materials': 'New Materials',
    'advanced-materials': 'Advanced Materials',
    'wire-connector': 'Wire & Connector',
    'wires-connectors': 'Wires & Connectors',
    other: 'Other',
    others: 'Others'
  },
  applicationNav: {
    'liquid-cooling': 'Liquid Cooling',
    automotive: 'Automotive',
    'hvac-refrigeration': 'HVAC/Refrigeration',
    hvac: 'HVAC/R',
    energy: 'Energy',
    battery: 'Battery',
    batteries: 'Batteries',
    semiconductor: 'Semiconductor',
    semiconductors: 'Semiconductors',
    'consumer-electronics': 'Consumer Electronics',
    'general-equipment': 'General Equipment',
    'medical-devices': 'Medical Devices',
    medical: 'Medical Devices',
    'home-appliances': 'Home Appliances',
    'defense-aerospace': 'Defense & Aerospace',
    aerospace: 'Aerospace & Defense',
    'new-materials': 'New Materials',
    'advanced-materials': 'Advanced Materials',
    'wire-connector': 'Wire & Connector',
    'wires-connectors': 'Wires & Connectors',
    other: 'Other',
    others: 'Others'
  },
  solutionSubNav: {
    uqd: 'UQD',
    'cold-plate': 'Cold Plate',
    manifold: 'Manifold',
    'corrugated-tube': 'Liquid Cooling Corrugated Tube',
    cdu: 'CDU',
    'liquid-cooling-cabinet': 'Liquid Cooling Cabinet',
    'die-castings': 'Die Castings',
    valve: 'Valve',
    'heat-exchanger': 'Heat Exchanger',
    'liquid-cooling-pump': 'Liquid Cooling Pump',
    engine: 'Engine',
    battery: 'Battery',
    transmission: 'Transmission',
    motor: 'Motor',
    ecu: 'ECU',
    'camera-radar': 'Camera/Radar',
    headlight: 'Headlight',
    'wire-harness': 'Wire Harness',
    tpms: 'TPMS',
    switch: 'Switch',
    other: 'Other',
    compressor: 'Compressor',
    pipeline: 'Pipeline',
    radiator: 'Radiator',
    'check-valve': 'Check Valve',
    'energy-storage': 'Energy Storage',
    hydrogen: 'Hydrogen Energy',
    'battery-cell': 'Battery Cell',
    pack: 'Pack',
    'soft-pack': 'Soft-pack Battery',
    'safety-vent': 'Safety Vent',
    'solid-state': 'Solid-state Battery',
    phone: 'Phone',
    watch: 'Watch',
    'smart-band': 'Smart Band',
    'ar-glasses': 'AR Glasses',
    earphone: 'Earphone',
    tablet: 'Tablet',
    computer: 'Computer',
    speaker: 'Speaker',
    robot: 'Robot',
    sensor: 'Sensor',
    pump: 'Pump',
    cylinder: 'Cylinder',
    endoscope: 'Endoscope',
    stethoscope: 'Stethoscope',
    aircraft: 'Aircraft',
    uav: 'UAV',
    missile: 'Missile',
    satellite: 'Satellite',
    connector: 'Connector',
    'shock-absorber': 'Shock Absorber',
    'water-tank': 'Water Tank',
    'battery-pack': 'Battery Pack'
  },
  newsNav: {
    'tech-wiki': 'Tech Wiki',
    'company-news': 'Corporate News',
    exhibition: 'Events',
    industry: 'Industry Insights',
    social: 'CSR'
  },
  serviceNav: {
    'product-support': 'Product Support',
    'value-added': 'Value-added Services',
    faq: 'FAQs'
  },
  aboutNav: {
    'company-intro': 'Company Profile',
    history: 'Milestones',
    culture: 'Corporate Culture',
    rd: 'R&D Capabilities',
    honors: 'Certifications & Honors',
    careers: 'Careers'
  }
}
